import * as React from "react";
import Comment from "../../_data/models/Comment";
import {Link} from "react-router-dom";
import {UsersRoutes} from "../../routes";
import * as moment from "moment";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";

interface Props {
    comment: Comment,
}

const CommentItemComponent = (props: Props) => {
    const {comment} = props;

    if (!comment)
        return null;

    return (       
        <div>
            <div className="large-12 pb-half">
                <div className="row">
                    <div className="large-2 medium-2 columns pr-half">                                          
                        <UserRedirectContainer id={comment.user.id} element="a">
                            <img src={comment.user.profilePicture()} className="img-wrapper circle"/>
                        </UserRedirectContainer>
                    </div>
                    <div className="large-10 medium-10 columns paddingless">
                        <p className="marginless">
                            <UserRedirectContainer id={comment.user.id} element="a" className="inline">{comment.user.username()}</UserRedirectContainer> {comment.text}
                        </p>
                        <label>{moment(comment.createdAt).fromNow()}</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentItemComponent;


// WEBPACK FOOTER //
// ./app/client/comment/components/CommentItemComponent.tsx